/* nc-blog-article — sommaire, scroll-spy et progression de lecture.
   Progressive enhancement : sans JS, la nav reste [hidden] et la barre aussi.
   Aucune dependance. L'offset de scroll sous le header sticky est gere par
   html{scroll-padding-top} (nc-common.css) + scroll-margin-top sur les h2. */
(function () {
  'use strict';

  var body = document.querySelector('.nc-article__body');
  if (!body) return;

  var headings = [].slice.call(body.querySelectorAll('h2'));
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Sommaire ────────────────────────────────────────────────────────── */
  var toc = document.querySelector('[data-nc-toc]');
  var list = toc && toc.querySelector('.nc-article__toc-list');

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
  }

  if (toc && list && headings.length >= 3) {
    var used = Object.create(null);
    var frag = document.createDocumentFragment();

    headings.forEach(function (h) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent || '');
        var base = id;
        var n = 2;
        while (used[id] || document.getElementById(id)) id = base + '-' + n++;
        h.id = id;
      }
      used[id] = true;

      var li = document.createElement('li');
      li.className = 'nc-article__toc-item';
      var a = document.createElement('a');
      a.className = 'nc-article__toc-link';
      a.href = '#' + id;
      // Le libelle est dans un span : le numero mono vient d'un ::before, et le
      // soulignement au survol ne doit porter que sur le texte.
      var span = document.createElement('span');
      span.className = 'nc-article__toc-link-text';
      span.textContent = h.textContent || '';
      a.appendChild(span);
      li.appendChild(a);
      frag.appendChild(li);
    });

    list.appendChild(frag);
    toc.removeAttribute('hidden');
  }

  /* Pas de scroll-spy : le sommaire est un bandeau en tete d'article, il defile
     avec le contenu. Le reperage pendant la lecture est assure par la barre de
     progression ci-dessous. */

  /* ── Progression de lecture ──────────────────────────────────────────── */
  var progress = document.querySelector('[data-nc-progress]');
  if (progress && !reduced) {
    var bar = progress.querySelector('.nc-article__progress-bar');
    var ticking = false;

    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) { progress.setAttribute('hidden', ''); return; }
      var pct = (-rect.top / total) * 100;
      pct = Math.max(0, Math.min(100, pct));
      progress.removeAttribute('hidden');
      bar.style.transform = 'scaleX(' + (pct / 100).toFixed(4) + ')';
      progress.setAttribute('aria-valuenow', Math.round(pct));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }
})();
